import { Dispatch } from 'redux';

import {
  MainStoreSearchRadiusAction,
  SetSearchRadiusAction,
} from './searchRadius';

export function setSearchRadiusFunction(
  radius: string,
  didUserChange: boolean,
): SetSearchRadiusAction {
  return {
    type: 'SEARCH_RADIUS_SET',
    radius,
    didUserChange,
  };
}

export function setSearchRadius(radius: string, didUserChange: boolean) {
  return (dispatch: Dispatch<MainStoreSearchRadiusAction>) => {
    dispatch(setSearchRadiusFunction(radius, didUserChange));
  };
}
